angular.
module("dx.webapp.integrations").
component("dxSkolonIntegrations", {
	templateUrl: "tmpl/integrations/skolon-integrations-component.html",
	controller: "DxSkolonIntegrationsController",
	controllerAs: "vm",
	bindings: {
		node: "<",
	},
});
